import PropTypes from "prop-types";
import classnames from "classnames";

import yourInputsIcon from "apps/QuoterApp/assets/images/Your inputs - Icon.svg";
import whatWeDoIcon from "apps/QuoterApp/assets/images/What we do - Icon.svg";
import peaceOfMindIcon from "apps/QuoterApp/assets/images/Peace of Mind - Icon.svg";

import './styles.scss';


function SideBarIconSection({className}) {
    return <div className={classnames("IconSection", className)}>
        <img src={yourInputsIcon} alt={"Your Inputs"}/>
        <div className={"IconSection__Title"}>Your Inputs</div>
        <div className={"IconSection__Text"}>
            The more accurate your inputs, the more realistic our solutions. Help us provide you with the most accurate & meaningful results.
        </div>

        <img src={whatWeDoIcon} alt={"What We Do"}/>
        <div className={"IconSection__Title"}>What We Do</div>
        <div className={"IconSection__Text"}>
            We’ve shopped the marketplace extensively to provide the best products available, combining the latest technology with our licensed insurance experts to provide a streamlined yet personalized process.
        </div>

        <img src={peaceOfMindIcon} alt={"Peace of Mind"}/>
        <div className={"IconSection__Title"}>Peace of Mind</div>
        <div className={"IconSection__Text"}>
            Your information stays secure and is not used for any other purposes. No Sharing and No Spam.
        </div>
    </div>;
}

SideBarIconSection.propTypes = {
    className: PropTypes.string,
}

export default SideBarIconSection;
